export const paymentStatus = [
  { id: 'paid', name: 'Paid' },
  { id: 'unpaid', name: 'Unpaid' },
  { id: 'pending', name: 'Pending' },
]
export default paymentStatus
